var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.8H2.88889M2.88889 4.8H18M2.88889 4.8V18.1C2.88889 18.6039 3.0879 19.0872 3.44213 19.4435C3.79637 19.7998 4.27681 20 4.77778 20H14.2222C14.7232 20 15.2036 19.7998 15.5579 19.4435C15.9121 19.0872 16.1111 18.6039 16.1111 18.1V4.8H2.88889ZM5.72222 4.8V2.9C5.72222 2.39609 5.92123 1.91282 6.27547 1.5565C6.6297 1.20018 7.11015 1 7.61111 1H11.3889C11.8899 1 12.3703 1.20018 12.7245 1.5565C13.0788 1.91282 13.2778 2.39609 13.2778 2.9V4.8M7.61111 9.55V15.25M11.3889 9.55V15.25",
    stroke: "#9D9D9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.b22821b10f6750f9c919e3de3162d71f.svg";
export { ForwardRef as ReactComponent };